import React from "react";
import { IGateway } from "@grabcad/company-server-shared/dist/types";
import { CloudAccessType } from "../../../../graphql";

import { CardGrid, GridWrapper } from "./GatewayCardGrid.style";
import GatewayCard from "./GatewayCard/GatewayCard";
import AddGatewayCard from "./AddGatewayCard/AddGatewayCard";

type GatewayCardGridProps = {
    gateways: IGateway[];
    page: number;
    setCheckIfPollingTrue: (setProperty: boolean) => void;
    setNewThingName: (setThingName: string) => void;
    newThingName?: string;
    onSuccessfullRequest: () => void;
    printerSerial?: string;
    cloudAccessType?: CloudAccessType;
    onGatewayRemoved: (coreDeviceThingName: string) => void;
};

const GatewayCardGrid: React.FC<GatewayCardGridProps> = ({
    gateways,
    page,
    setCheckIfPollingTrue,
    setNewThingName,
    onSuccessfullRequest,
    printerSerial,
    cloudAccessType,
    onGatewayRemoved,
}) => {
    return (
        <GridWrapper>
            <CardGrid>
                {page === 1 && (
                    <AddGatewayCard
                        setCheckIfPollingTrue={setCheckIfPollingTrue}
                        setNewThingName={setNewThingName}
                        onSuccessfullRequest={onSuccessfullRequest}
                        printerSerial={printerSerial}
                        cloudAccessType={cloudAccessType}
                    />
                )}

                {gateways.map((gateway) => (
                    <GatewayCard
                        key={gateway.coreDeviceThingName}
                        gateway={gateway}
                        printerSerial={printerSerial}
                        onGatewayRemoved={onGatewayRemoved}
                    />
                ))}
            </CardGrid>
        </GridWrapper>
    );
};

export default GatewayCardGrid;
